//@flow
import _ from 'lodash';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withStateHandlers from 'recompose/withStateHandlers';

export default compose(
    withStateHandlers(
        {
            selectedRows: [],
            allFilteredEntitiesSelected: false,
            showEmptyState: false
        },
        {
            setSelectedRows: () => selectedRows => {
                return {
                    selectedRows
                };
            },
            setShowEmptyState: () => showEmptyState => {
                return {
                    showEmptyState
                };
            },
            setAllFilteredEntitiesSelected: () => allFilteredEntitiesSelected => {
                return {
                    allFilteredEntitiesSelected
                };
            }
        }
    ),
    withHandlers({
        selectAllRows: ({ setSelectedRows, data }) => () => {
            if (!data) {
                return;
            }
            const { entities } = data;
            setSelectedRows(entities.map(entity => entity.id));
        }
    }),
    withHandlers({
        onSelectAllFilteredEntities: ({
            setAllFilteredEntitiesSelected,
            selectAllRows
        }) => () => {
            setAllFilteredEntitiesSelected(true);
            selectAllRows();
        },
        toggleRowSelection: ({
            setAllFilteredEntitiesSelected,
            setSelectedRows,
            selectedRows
        }) => (id: string) => {
            setAllFilteredEntitiesSelected(false);
            if (selectedRows.indexOf(id) >= 0) {
                setSelectedRows(_.without(selectedRows, id));
            } else {
                setSelectedRows(selectedRows.concat([id]));
            }
        },
        toggleSelectAll: ({
            setAllFilteredEntitiesSelected,
            setSelectedRows,
            selectedRows,
            data,
            selectAllRows
        }) => () => {
            if (!data) {
                return;
            }
            const { entities } = data;
            setAllFilteredEntitiesSelected(false);
            if (selectedRows.length === entities.length) {
                setSelectedRows([]);
            } else {
                selectAllRows();
            }
        }
    })
);
